import React, {useRef} from "react";
import {MapContainer, TileLayer} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "./DevicesMap.scss";
import MapContent from "./map-content/MapContent";

const DevicesMap = () => {
    const mapRef = useRef(null);
    return (
        <div className="relative">
            <MapContainer
                id="map"
                zoom={16}
                scrollWheelZoom={true}
                doubleClickZoom={false}
                zoomControl={false}
                ref={mapRef}
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
            <MapContent mapRef={mapRef}/>
            </MapContainer>
        </div>
    );
};

export default DevicesMap;
